<script lang="ts">
import { onMount } from "svelte";
import DBG from "../code/DBG";



    export let taskTypeToColor: any[];
    onMount(()=>{
        DBG.log("Legend - onMount", taskTypeToColor);
    });
</script>

<div id="chart-legend">
    {#each taskTypeToColor as tttc}
    <div class="color-entry">
        <div class="color-legend" style="border-left: 1rem solid {tttc.color};">
            
        </div>
        <div class="color-text" >
            {tttc.text || "Undefined"}
        </div>
    </div>       
    {/each}
</div>

<style>
    .color-legend{
        width:1rem;
        height: 1rem;
        margin-left: 1rem;
    }
    .color-entry{
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0.5rem;
    }
    .color-text{
        margin-left: 1rem;
        text-align: left;
    }
</style>